import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router';
import ReactGA from "react-ga4";
import Loader from "Components/Loader";

const PromptContainer = styled.div`
    display: flex;
    align-items:center;
    justify-content: center;
    flex-wrap: wrap;
`;

const NotFoundPrompt = styled.div`
    text-align:center;
    padding:20px;
    color: var(--main-grey-color);
`;

const BoldText = styled.p`
    font-family: Lato-Bold;
    font-size:2rem;
`;

const BodyText = styled.p`
    font-family: Lato-Regular;
    font-size:1.6rem;
`;

function PaymentProcess() {
    
    const params = new URLSearchParams(window.location.search);
    var isNew = params.get('isnew') as string;
    var status = params.get('status') as string;
    var booking_id = params.get('bookingid') as string;
    var message = params.get('message') as string;
    var redirect = isNew == "1" ? `/LicenceCheck/${booking_id}` : `/BookingPayments/${booking_id}`;
    if (status=="fail") redirect="/";

    const navigate = useNavigate();
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    useEffect(() => {
        setTimeout(() => navigate(redirect), 5000)
    }, []);

    return (
        <PromptContainer>
            <NotFoundPrompt>
                <BoldText>{status == "ok" ? "Thank you" : "Transaction cancelled"}</BoldText>
                <BodyText>{message}</BodyText>
                <Loader/>
            </NotFoundPrompt>
        </PromptContainer>
    );
}
export default PaymentProcess;